import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ComponentData, TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'risk-equity-deep-dive',
	templateUrl: './equity-deep-dive.component.html',
	styleUrls: ['./equity-deep-dive.component.scss']
})
export class EquityDeepDiveComponent implements OnChanges, OnInit {

	@Input() public data: ComponentData;

	public asOfDate: string;
	public asOfDateSNP: string;
	public activeSumTab: TabData;
	public totalSumTab: TabData;
	public decompHeaderTab: TabData;
	public decompositionTabs: TabData[] = [];
	public subTitle: string;
	public title: string;

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		this.subTitle = this.contentService.get('EQUITY_DEEP_DIVE_SUBTITLE', 'EQUITY_DEEP_DIVE_SUBTITLE');
		this.title = this.contentService.get('EQUITY_DEEP_DIVE_TITLE', 'Equity Deep Dive');
	}

	public ngOnChanges(): void {
		if (this.data.success) {
			const asOfDateTab = this.data.getTabById('risk.asOfDate');
			this.asOfDate = get(asOfDateTab, 'displayConfig.visible') && get(asOfDateTab, 'tableData[0].cells[0][0].formattedValue');
			const asOfDateSNPTab = this.data.getTabById('risk.asOfDate.snp');
			this.asOfDateSNP = get(asOfDateSNPTab, 'displayConfig.visible') && get(asOfDateSNPTab, 'tableData[0].cells[0][0].formattedValue');
			this.activeSumTab = this.data.getTabById('equity.active.risk.sum');
			this.totalSumTab = this.data.getTabById('equity.total.risk.sum');
			this.decompHeaderTab = this.data.getTabById('eq.risk.decomposition.header');
			const eqActiveRiskDecompTab = this.data.getTabById('eq.active.risk.decomposition');
			const eqTotalRiskDecompTab = this.data.getTabById('eq.total.risk.decomposition');
			if (eqTotalRiskDecompTab) {
				this.decompositionTabs.push(eqTotalRiskDecompTab);
			}
			if (eqActiveRiskDecompTab) {
				this.decompositionTabs.push(eqActiveRiskDecompTab);
			}
		}
	}
}
